import { FC } from "react";
import Select from "./Select";
import { Col, Row } from "react-bootstrap";

export interface ISelectArchiveYearMonth {
    label: string,
    value: number 
}

export interface ISelectArchiveCategory {
    label: string,
    value: string 
}

interface ISelectArchiveFilters {
    selectedMonth: ISelectArchiveYearMonth,
    monthsOptions: ISelectArchiveYearMonth[]
    onMonthChange: (e: ISelectArchiveYearMonth) => void
    selectedYear: ISelectArchiveYearMonth,
    yearsOptions: ISelectArchiveYearMonth[]
    onYearChange: (e: ISelectArchiveYearMonth) => void,
    selectedCategory: ISelectArchiveCategory,
    categoriesOptions: ISelectArchiveCategory[]
    onCategoryChange: (e: ISelectArchiveCategory) => void
}

const SelectArchiveFilters: FC<ISelectArchiveFilters> = ({
    selectedMonth,
    monthsOptions,
    onMonthChange,
    selectedYear,
    yearsOptions,
    onYearChange,
    selectedCategory,
    categoriesOptions,
    onCategoryChange
}) => {
    return <div className="select-archive-filter">
        <Row>
            <Col sm={4}>
                <label htmlFor="year-select" className="mx-2 fw-bold">Anno</label>
                <Select
                    id="year-select"
                    name="year-select"
                    className="archive-select"
                    defaultValue={yearsOptions[0]}
                    value={selectedYear}
                    options={yearsOptions}
                    onChange={async (e) => await onYearChange(e)}
                />
            </Col>
            <Col sm={4}>
                <label htmlFor="month-select" className="mx-2 fw-bold">Mese</label>
                <Select
                    id="month-select"
                    name="month-select"
                    className="archive-select"
                    defaultValue={monthsOptions[0]}
                    value={selectedMonth}
                    options={monthsOptions}
                    onChange={async (e) => await onMonthChange(e)}
                />
            </Col>
            <Col sm={4}>
                <label htmlFor="category-select" className="mx-2 fw-bold">Categoria</label>
                <Select
                    id="category-select"
                    name="category-select"
                    className="archive-select"
                    defaultValue={categoriesOptions[0]}
                    value={selectedCategory}
                    options={categoriesOptions}
                    onChange={async (e) => onCategoryChange(e)}
                />
            </Col>
        </Row>
    </div>
}

export default SelectArchiveFilters